<template>
  <b-container style="margin-top:90px;" class="container-fluid d-flex h-100 flex-column">
    <b-row class="h-100">
      <b-col cols="10" offset="1" xl="4" offset-xl="4" class="align-self-center">
        <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>{{ErrorText}}</b-alert>

        <b-card class="shadow" v-if="resetStep == 0">
          <b-form @submit="onSubmitStep1">
            <b-form-group id="input-group-1" :label="$t('USERNAME')" label-for="input-1">
              <b-form-input
                id="input-1"
                v-model="form1.Username"
                type="text"
                required
                :placeholder="$t('ENTER_USERNAME')"
              ></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary">{{$t("RESET_PW")}}</b-button>
          </b-form>
        </b-card>

        <b-card class="shadow" :header="$t('ANSWER_SQ')" v-if="resetStep == 1">
          <b-form @submit="onSubmitStep2">
            <b-form-group id="input-group-fsq" :label="$t('F_SQ')" label-for="fsq">
              <span>{{form2.qOneText}}</span>
            </b-form-group>
            <b-form-group>
              <b-form-input
                v-model="form2.qOneAnswer"
                type="text"
                required
                :placeholder="$t('ENTER_ANSWER')"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-ssq" :label="$t('S_SQ')" label-for="ssq">
              <span>{{form2.qTwoText}}</span>
            </b-form-group>
            <b-form-group>
              <b-form-input
                v-model="form2.qTwoAnswer"
                type="text"
                required
                :placeholder="$t('ENTER_ANSWER')"
              ></b-form-input>
            </b-form-group>

            <div class="d-flex align-items-center">
              <b-button type="submit" variant="primary">{{$t("APPLY")}}</b-button>
            </div>
          </b-form>
        </b-card>


        <b-card class="shadow" v-if="resetStep == 2">
          <b-form @submit="onSubmitStep3">
            <b-form-group id="input-group-3" :label="$t('NEW_PW')" label-for="input-3">
              <b-form-input
                id="input-3"
                v-model="form3.password"
                type="text"
                required
                :placeholder="$t('NEW_PW')"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-4" :label="$t('NEW_PW_AGAIN')" label-for="input-4">
              <b-form-input
                id="input-4"
                v-model="form3.password2"
                type="text"
                required
                :placeholder="$t('NEW_PW_AGAIN')"
              ></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary">{{$t("RESET_PW")}}</b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import {ajaxGet, ajaxPost, ajaxPut } from '../../ajax';
import {apiUrl} from "@/main";

export default {
  data: function() {
    return {
      form1: {
        Username: ""
      },
      form2: {
        qOneID: 0,
        qTwoID: 0,
        qOneAnswer: "",
        qTwoAnswer: "",
        qOneText: "",
        qTwoText: ""
      },
      form3: {
        password: "",
        password2: ""
      },
      resetStep: 0,
      showDismissibleAlert: false,
      ErrorText: "",
      resetCode: null
    };
  },
  methods: {
    onError: function(status = 0) {
      if(status == 500 && this.resetStep == 0) {
        this.ErrorText = "Username not found!"
        this.showDismissibleAlert = true;
      }

      if(status == 401) {
        this.ErrorText = "There was an incorrect security question answer!"
        this.showDismissibleAlert = true;
      }

      if(status == 500 && this.resetStep == 2) {
        this.ErrorText = "There was a problem, try again!"
        this.showDismissibleAlert = true;
      }
    },
    onSubmitStep1: function(event) {
      event.preventDefault();
      ajaxGet(apiUrl() +"/auth/securityquestions/" + btoa(this.form1.Username), this.onSuccess1, this.onError, null);
    },
    onSuccess1: function(data) {
      this.resetStep = 1;

      this.form2.qOneID = data[0].ID;
      this.form2.qTwoID = data[1].ID;
      this.form2.qOneText = data[0].Question;
      this.form2.qTwoText = data[1].Question;
    },
    onSubmitStep2: function(event) {
      event.preventDefault();

      ajaxPut(apiUrl() +"/auth/securityquestions/" + btoa(this.form1.Username), 
      [
        {ID: this.form2.qOneID, Answer: this.form2.qOneAnswer},
        {ID: this.form2.qTwoID, Answer: this.form2.qTwoAnswer}
      ], this.onSuccess2, this.onError, null);
    },
    onSuccess2: function(data) {
      this.resetCode = data.ResetCode;
      this.resetStep = 2;
    },
    onSubmitStep3: function(event) {
      event.preventDefault();

      if(this.form3.password != this.form3.password2) {
        this.ErrorText = "Passwords must match!"
        this.showDismissibleAlert = true;
        return;
      }

      ajaxPost(apiUrl() + "/auth/pwreset", {resetcode: this.resetCode, password: this.form3.password}, this.onSuccess3, this.onError, null);
    },
    onSuccess3: function() {
      this.$bvToast.toast('Your password has been updated!', { autoHideDelay: 5000, appendToast: true});
      this.$router.push('/');
      this.resetStep = 0;
    }
  }
};
</script>